import { useQuery } from "@tanstack/react-query";
import clientService from "../api/clientService";

export const useClients = () => {
  const { getClients } = clientService();

  return useQuery({
    queryKey: ["get-clients"],
    queryFn: async () => {
      const res = await getClients();
      return res.data;
    },
  });
};
